module.exports = __webpack_public_path__ + "static/media/acores-pesca.125061af.png";